import React from "react";

const SvgIcnSetting = props => (
  <svg data-name="\u30EC\u30A4\u30E4\u30FC 1" width={24} height={24} {...props}>
    <path
      d="M22 12.93v-1.86l-3-.88a7.46 7.46 0 0 0-.76-1.83l1.53-2.77-1.36-1.32-2.77 1.53a7.46 7.46 0 0 0-1.83-.8l-.88-3h-1.86l-.88 3a7.46 7.46 0 0 0-1.83.76L5.59 4.27 4.27 5.59 5.8 8.36a7.46 7.46 0 0 0-.8 1.83l-3 .88v1.86l3 .88a7.46 7.46 0 0 0 .76 1.83l-1.49 2.77 1.32 1.32 2.77-1.53a7.46 7.46 0 0 0 1.83.76l.88 3h1.86l.88-3a7.46 7.46 0 0 0 1.83-.76l2.77 1.53 1.32-1.32-1.53-2.77a7.46 7.46 0 0 0 .8-1.83zm-7.3 1.77a3.82 3.82 0 1 1 0-5.4 3.82 3.82 0 0 1 0 5.4z"
      fill="#fff"
    />
  </svg>
);

export default SvgIcnSetting;
